import Graphic from "@arcgis/core/Graphic";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol";

export function Flash(geometry, geometryType, mapView) {

    let type = geometryType

    const graphic = new Graphic({
        geometry: geometry,
    });

    if (type == "point") {

        graphic.symbol = {
            type: 'simple-marker',
            color: '#00FFFF',
            size: '24px'
        }
    } else if (type == "polygon") {

        const flashSymbol = new SimpleFillSymbol({
            color: '#00FFFF',
            outline: {
                color: '#00008b',
                width: 1,
            },
        });
        graphic.symbol = flashSymbol
    } else if (type == "polyline") {
        const lineSymbol = new SimpleLineSymbol({
            color: '#00FFFF',
            width: 4
        });
        graphic.symbol = lineSymbol
    }
    mapView.graphics.add(graphic);
    const flashGraphic = () => {
        graphic.symbol.size = graphic.symbol.size === '24px' ? '20px' : '24px';
        mapView.graphics.remove(graphic);
        mapView.graphics.add(graphic);
        setTimeout(() => {
            mapView.graphics.remove(graphic); // remove graphic after 1 second
        }, 500);
    };
    flashGraphic();
    setTimeout(() => {
        flashGraphic();
    }, 1000);
    setTimeout(() => {
        flashGraphic();
    }, 2000);
}